"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAttributes = exports.ValidateProducts = exports.PatchProducts = exports.GetProductsByGroupingCode = exports.GetProduct = exports.GetProducts = void 0;
const effect_1 = require("effect");
exports.GetProducts = effect_1.Request.tagged('GetProducts');
exports.GetProduct = effect_1.Request.tagged('GetProduct');
exports.GetProductsByGroupingCode = effect_1.Request.tagged('GetProductsByGroupingCode');
exports.PatchProducts = effect_1.Request.tagged('PatchProducts');
exports.ValidateProducts = effect_1.Request.tagged('ValidateProducts');
exports.GetAttributes = effect_1.Request.tagged('GetAttributes');
